if (!customElements.get('featured-collection-buttons')) {
  customElements.define(
    'featured-collection-buttons',
    class FeaturedCollectionButtons extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.renderButtons();
      }

      renderButtons() {
        const buttons = this.querySelectorAll('[data-button-label]');
        buttons.forEach((btn) => {
          const label = btn.getAttribute('data-button-label');
          const link = btn.getAttribute('data-button-link');
          const anchor = btn.querySelector('a, button');

          if (anchor && label) {
            anchor.textContent = label;
          }

          if (anchor && link) {
            anchor.setAttribute('href', link);
          }
        });
      }
    }
  );
}
